import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { normalizeBigInt } from "../shared/lib/normalizeBigInt";
import { clearAuthTokens, getAuthToken, redirectToLoginIfNeeded } from "../shared/lib/authSession";
import { Code, ConnectError } from "@connectrpc/connect";
import { apiError } from "./apiError";
import { ErrorCode } from "../proto/general";

type ConnectQueryArgs = {
  client: any;
  method: string;
  args?: unknown;
};

export const connectBaseQuery =
  (): BaseQueryFn<ConnectQueryArgs, unknown, unknown> =>
  async ({ client, method, args }) => {
    const sentToken = getAuthToken();
    try {
      const data = await client[method](args);
      return { data: normalizeBigInt(data) };
    } catch (error: any) {
      const failure = apiError(error);
      // Deliberately narrower than isAuthFailureError: only a rejected token
      // ends the session here. AUTH_EXPIRED means "refresh", and the refresh
      // interceptor upstream owns that. A token that changed while the call
      // was out was stored by a refresh or a login, possibly in another tab,
      // and is not this failure's to wipe.
      if (
        (ConnectError.from(error).code === Code.Unauthenticated ||
          failure.code === ErrorCode.ERROR_CODE_AUTH_TOKEN_ISSUE) &&
        getAuthToken() === sentToken
      ) {
        clearAuthTokens();
        redirectToLoginIfNeeded();
      }

      console.error(`[rpc] ${method} failed`, { args, error });

      return { error: failure };
    }
  };
